import { defineComponent as _defineComponent } from 'vue'
import TimelineHeader from '@/components/timeline/TimelineHeader.vue';

// Shadow bids render no wrapper i.e. no timeline bullet, no header, no block margin.

export default /*#__PURE__*/_defineComponent({
  __name: 'SRTrendingTimelineItemWrapper',
  props: {
    hasCampaign: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,TimelineHeader }
}

})